export const getDSAWorkflowSubmitButtonLabel = ({ dsa, clone, convert, convertCustomer }) => {
  if (convertCustomer) {
    return dsa.is_test ? 'Convert Assessment' : 'Done' ;
  }
  if (convert || clone) {
    return 'Clone Assessment';
  }

  return 'Create Assessment';
};

export const getDSAWorkflowSubmitButtonLoadingLabel = ({ clone, convert, convertCustomer }) => {
  if (convert || clone) {
    return 'Cloning…';
  }

  if (convertCustomer) {
    return 'Converting…';
  }

  return 'Creating…';
};



// WEBPACK FOOTER //
// ./src/utils/createDSAWorkflowHelpers.js